export { default } from "./payorsTypeAhead";
